import { useIsAuthenticated } from "react-auth-kit"
import { Navigate, Outlet } from "react-router-dom"

export default function ProtectedRoute() {
    const isAuthenticated = useIsAuthenticated()

    return isAuthenticated() ? <Outlet/> : <Navigate to="/login"/>
}